import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../design-system/Card';

const AccountTypeSelector = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full animate-fadeIn">
        <div className="text-center mb-8 animate-slideUp">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            Welcome to FitGenie
          </h1>
          <p className="text-lg text-gray-600">
            Your AI-powered fitness journey starts here
          </p>
        </div>

        <div className="space-y-4">
          <Card
            variant="interactive"
            onClick={() => navigate('/register/athlete')}
            className="animate-slideUp"
            style={{ animationDelay: '100ms' }}
          >
            <div className="flex items-center space-x-4">
              <div className="text-4xl">🏃‍♂️</div>
              <div className="text-left flex-1">
                <h3 className="text-xl font-semibold text-gray-900">
                  I'm an Athlete
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  Get personalized AI training plans tailored to your goals
                </p>
              </div>
              <svg
                className="w-5 h-5 text-gray-400 transition-colors"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </Card>

          <Card
            variant="interactive"
            onClick={() => navigate('/register/coach')}
            className="animate-slideUp"
            style={{ animationDelay: '150ms' }}
          >
            <div className="flex items-center space-x-4">
              <div className="text-4xl">👨‍🏫</div>
              <div className="text-left flex-1">
                <h3 className="text-xl font-semibold text-gray-900">
                  I'm a Coach
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  Manage clients and create custom training programs
                </p>
              </div>
              <svg
                className="w-5 h-5 text-gray-400 transition-colors"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </Card>

          <Card
            variant="interactive"
            onClick={() => {
              // Set guest mode and navigate to dashboard
              localStorage.setItem('guestMode', 'true');
              navigate('/dashboard');
            }}
            className="animate-slideUp bg-gray-50"
            style={{ animationDelay: '200ms' }}
          >
            <div className="flex items-center space-x-4">
              <div className="text-4xl">🏅</div>
              <div className="text-left flex-1">
                <h3 className="text-xl font-semibold text-gray-900">
                  Continue as Guest
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  Explore features with limited access
                </p>
              </div>
              <svg
                className="w-5 h-5 text-gray-400 transition-colors"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </Card>
        </div>

        <div className="mt-8 text-center animate-slideUp" style={{ animationDelay: '250ms' }}>
          <p className="text-sm text-gray-600">
            Already have an account?{' '}
            <a
              href="/login"
              className="font-medium text-[#4B5FDC] hover:text-[#3A4BC9] transition-colors"
            >
              Sign in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccountTypeSelector;